var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$store.state.mxLookup[_vm.merchantId])?_c('span',[_vm._v(_vm._s(_vm.$store.state.mxLookup[_vm.merchantId].name)+" "),(!_vm.hideId)?_c('small',{staticClass:"text-secondary"},[_c('br'),_vm._v(_vm._s(_vm.merchantId))]):_vm._e()]):_c('span',[_vm._v(_vm._s(_vm.merchantId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }